export default __webpack_public_path__ + "static/media/robot_start.c5236699.png";